/* eslint-disable */
import { call, put, select, take, fork, cancel, cancelled } from 'redux-saga/effects'
import { path } from 'ramda'
import ShoppableActions from '../Redux/ShoppableRedux'
import { showError, shoppableProductToKargoeItem, isShoppableItemId } from '../Lib/utils'
//import RNFetchBlob from 'react-native-fetch-blob'
import { MEDIA_TYPES } from '../Constant'
import { KargoeConfig } from '../Config/AppConfig'

export function* shoppableGetConfig(api, action) {
  let state = null
  try {
    const fullState = yield select() // the entire app state
    state = fullState.shoppable
    let config = Object.assign({}, state.config)
    console.tron.display({
      name: `shoppable`,
      preview :`shoppableGetConfig state`,
      value: {
        state: state
      }
    })
    if (config.fetching) {
      const configResponse = yield call(api.getShoppableConfig, {})
      console.tron.display({
        name: `shoppable`,
        preview :`shoppableGetConfig configResponse ` + (configResponse.ok ? 'success' : 'failure'),
        value: {
          configResponse: configResponse
        }
      })
      if (configResponse.ok) {
        const headers = configResponse.data.data.headers
        const baseURI = configResponse.data.data.baseURI
        let config = {
          fetching:   false,
          modified:   Date.now(),
          error:      null,
          headers:    headers,
          data:       configResponse.data.data,
        }
        const stateChange = {
          config: config
        }
        console.tron.display({
          name: `shoppable`,
          preview :`shoppableGetConfig update config`,
          value: {
            stateChange: stateChange
          }
        })
        yield call(api.shoppableSetHeaders, headers) // cannot fail
        yield call(api.shoppableSetBaseURL, baseURI)
        yield put(ShoppableActions.shopStateChange(stateChange))
      }
      else {
        yield put(ShoppableActions.shopStateChange({
          config: {
            error: "Unable to get Shoppable headers",
            modified: Date.now(),
          }
        }))
        return
      }
    }
    else {
      console.tron.log("shoppableGetConfig using cached config")
      yield call(api.shoppableSetHeaders, state.config.headers) // If you include API in your container, this must be done as you've created another copy of API in the system
      yield call(api.shoppableSetBaseURL, state.config.data.baseURI)
      yield put(ShoppableActions.shopStateChange({}))
    }
  }
  catch (e) {
    showError(e)
    const errorItems = { items: Object.assign({}, state.items, { modified: Date.now(), fetching: false, error: "Shoppable getConfig failed. " + e.message, list: [] }) }
    yield put(ShoppableActions.shopStateChange(errorItems))
  }
}

buildShoppableQuery = (state, search, start, limit, options) => {
  let config = Object.assign({}, state.config)
  let finalSearch = new String(search)

  // find merchants, brands, colors, etc, that we recognize and handle them specially
  const merchants = config.data.merchants ? config.data.merchants : []
  console.tron.display({
    name: `shoppable`,
    preview :`buildShoppableQuery config`,
    value: {
      state: state,
      search: search,
      start: start,
      limit: limit,
      config: config,
      merchants: merchants,
    }
  })
  let searchQuery = []
  let merchantIdQuery = []
  for (var i = 0; i < merchants.length; i++) {
    merchantName = merchants[i]['name']
    const found = finalSearch.match(new RegExp("\\b" + merchantName + "\\b", "i")) // https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9781449327453/ch02s06.html
    if (found) {
      console.tron.log(`shoppable found merchant ${merchantName}`)
      // searchQuery.push(`merchant_id:${merchants[i]['id']}`)
      merchantIdQuery.push(merchants[i]['id'])
      finalSearch = finalSearch.replace(new RegExp("\\b" + merchantName + "\\b", "ig"), '') // \\b is word boundary
    }
  }
  // no specific merchant found in search?  then limit to all allowed merchants
  if (merchantIdQuery.length == 0)
    for (var i = 0; i < merchants.length; i++) {
      merchantIdQuery.push(merchants[i]['id'])
    }

  let brandQuery = []
  if (typeof options.brandName != 'undefined')
    brandQuery.push(options.brandName)
  else {
    const brands = config.data.brands ? config.data.brands : []
    for (var i = 0; i < brands.length; i++) {
      const brand = brands[i];
      const found = finalSearch.match(new RegExp("\\b" + brand + "\\b", "i"))
      if (found) {
        console.tron.log(`shoppable found brand ${brand}`)
        brandQuery.push(brand)
        finalSearch = finalSearch.replace(new RegExp("\\b" + brand + "\\b", "ig"), '')
      }
    }
  }

  let colorQuery = []
  /*
  const colors = config.data.colors
  for (var i = 0; i < colors.length; i++) {
    const color = colors[i];
    const found = finalSearch.match(new RegExp("\\b" + color + "\\b", "i"))
    if (found) {
      console.tron.log(`shoppable found color ${color}`)
      colorQuery.push(color)
      finalSearch = finalSearch.replace(new RegExp("\\b" + color + "\\b", "ig"), '')
    }
  }
*/

  searchQuery = searchQuery.join(' ').trim()
  finalSearch = finalSearch.trim().split(' ').join(' AND ').trim()
  const parsedSearch = finalSearch == null || finalSearch === '' ? searchQuery : (searchQuery === '' ?  finalSearch : `(${searchQuery}) AND (` + finalSearch + ")")
  let query = Object.assign({}, {
    search: parsedSearch,
    offset: Math.max(0, start),
    rows:   limit,
    discount: 'all',
    navigation_type: 'none',
  })
  if (typeof options.sortBy == 'undefined')
    query.sort = '-last_modified'
  else if (options.sortBy != '')
    query.sort = options.sortBy
  if (brandQuery)
    query.brands = brandQuery.join(',')
  if (colorQuery)
    query.colors = colorQuery.join(',')
  if (merchantIdQuery)
    query.merchant_ids = merchantIdQuery.join(',')    
  return query
}

export function* shoppableSearchItems(api, action) {
  // KargoeTagSagas.js
  // starts the task in the background
  const bgSyncTask = yield fork(shoppableSearchItemsAsync, api, action)

  // wait for the user stop action
  yield take('SHOP_SEARCH_ITEMS')
  // user clicked stop. cancel the background task
  // this will cause the forked bgSync task to jump into its finally block
  yield cancel(bgSyncTask)
}

export function* shoppableSearchItemsAsync(api, action) {
  let search = ''
  let searchSettings = {}
  try {
    const fullState = yield select() // the entire app state
    const appOptions = fullState.postCreation.basePostWallOptions
    const state = fullState.shoppable
    console.tron.display({
      name: `shoppable`,
      preview :`shoppableSearchItemsAsync action`,
      value: {
        action: action,
        state: state,
      }
    })
    const shoppableItems = state.items
    const shoppableConfig = state.config
    const merchants = shoppableConfig.data && shoppableConfig.data.merchants ? shoppableConfig.data.merchants : []
    let items = []
    let { start = 0, limit = 100 } = action
    const { filter = '', search, options = {} } = action
    searchSettings = {
      start,
      limit,
      search,
      filter,
    }
    const shopifyUserId = options && typeof options.UserId != 'undefined' ? options.UserId : null
    const useShopify = typeof options.shoppableOnly == 'undefined' || !options.shoppableOnly
    const sortBy = typeof options.sortBy != 'undefined' ? options.sortBy : '-last_modified'
    
    if (['-last_modified', 'price', '-price', 'name', 'random', ''].indexOf(sortBy) == -1) {
      const failedItems = { items: Object.assign({}, state.items, { modified: Date.now(), fetching: false, error: `Unknown Shoppable sort method`, list: [] }, searchSettings) }
      yield put(ShoppableActions.shopStateChange(failedItems))
      return
    }
    
    // Handle blank search, return default - most recent items
    if (shopifyUserId == null && useShopify && search.trim() == '') {
      if (start > 0) {
        const noMoreDefaultItems = { items: Object.assign({}, state.items, { modified: Date.now(), fetching: false, list: [] }, searchSettings) }
        yield put(ShoppableActions.shopStateChange(noMoreDefaultItems))
        return
      }
      const cacheName = `getKargoeTag_default`
      const cachedItems = api.cacheGet(cacheName)
      if (cachedItems) {
        const defaultItems = { items: Object.assign({}, state.items, { modified: Date.now(), fetching: false, list: cachedItems }, searchSettings) }
        yield put(ShoppableActions.shopStateChange(defaultItems))
        return
      }
      const defaultResponse = yield call(api.getKargoeTag, { search: '', limit: 100, filter: "THEYSELL_ONLY" }) // maybe cache for a while in future...
      if (defaultResponse.ok) {
        api.cacheSet(cacheName, defaultResponse.data.data, 3600)
        const defaultItems = { items: Object.assign({}, state.items, { modified: Date.now(), fetching: false, list: defaultResponse.data.data }, searchSettings) }
        yield put(ShoppableActions.shopStateChange(defaultItems))
        return
      }
      else {
        const failedItems = { items: Object.assign({}, state.items, { modified: Date.now(), fetching: false, error: 'Kargoe Default Items API failed', list: [] }, searchSettings) }
        yield put(ShoppableActions.shopStateChange(failedItems))
        return
      }
    }

    // Handle Shopify items from Kargoe database
    let source = start == 0 ? 'kargoe' : state.items.source
    let kargoeRead = start == 0 ? 0 : state.items.kargoeRead
    let kargoeReadThisTime = 0
    if (useShopify && source == 'kargoe') {
      // search through theysell/Shopify records
      const responseKargoe = yield call(api.itemSearch, {start, limit, search, filter, UserId: shopifyUserId})
      if (responseKargoe.ok) {
        console.tron.display({
          name: `shoppable`,
          preview :`shoppableSearchItems: kargoe`,
          value: {
            search: search,
            numItems: responseKargoe.data.data.length,
            items: responseKargoe.data.data,
          }
        })
        if (responseKargoe.data.data.length > 0) {
          kargoeRead = start + responseKargoe.data.data.length
          kargoeReadThisTime = responseKargoe.data.data.length
          items = responseKargoe.data.data.concat([])
        }
      }
      else {
        const failedItems = { items: Object.assign({}, state.items, { modified: Date.now(), fetching: false, error: 'Kargoe Item Search API failed', list: [] }, searchSettings) }
        yield put(ShoppableActions.shopStateChange(failedItems))
        return
      }
    }

    // finally, add shoppable items to end
    if (shopifyUserId == null && KargoeConfig.shoppable.active && shoppableConfig.data && shoppableConfig.data.enabled && items.length < limit) {
      // append shoppable results
      source = 'shoppable'
      const shoppableStart = start + items.length - kargoeRead
      const query = buildShoppableQuery(state, search, shoppableStart, limit - kargoeReadThisTime, options)
      console.tron.log(`shoppableSearchItems: making shoppable call, search ${search}, itemCount: ${items.length}`)
      const response = yield call(api.shoppableCatalog, query)
      console.tron.display({
        name: `shoppable`,
        preview :`searchItems ` + (response.ok ? 'success' : 'failure'),
        value: {
          query: query,
          response: response,
          items: items,
          kargoeRead: kargoeRead,
        }
      })
      if (response.ok) {
        // const shoppableItems = response.data.products.map(shoppableProductToKargoeItem)
        const brandList = shoppableConfig.data && shoppableConfig.data.brands ? shoppableConfig.data.brands.map(v => v.toLowerCase()) : []
        // TODO brand filtering
        let shoppableItems = [] // make a copy...
        response.data.products.forEach(function (product) {
          if (product.brand && product.name && product.merchant && product.price)
            if (brandList.indexOf(product.brand.toLowerCase()) >= 0)
              shoppableItems.push(shoppableProductToKargoeItem(merchants, product))
        })
/*
        const shoppableItems = response.data.products.map(function (item) {
             return shoppableProductToKargoeItem(merchants, item);
          })
*/          
        console.tron.log(`Shoppable product count: ` + response.data.products.length + `, filtered by brand count: ` + shoppableItems.length)
        items = items.concat(shoppableItems)
      }
      else {
        const failedItems = { items: Object.assign({}, state.items, { modified: Date.now(), fetching: false, error: 'Shoppable Catalog API failed', list: [] }, searchSettings) }
        yield put(ShoppableActions.shopStateChange(failedItems))
        return
      }
    } // items

    const newItems = { items: Object.assign({}, state.items, { source, kargoeRead, filter, modified: Date.now(), fetching: false, list: items }, searchSettings) }
    console.tron.display({
      name: `shoppable`,
      preview :`searchItems search ${search}, processed items`,
      value: {
        items: items,
        newItems: newItems,
      }
    })
    yield put(ShoppableActions.shopStateChange(newItems))
  }
  catch (e) {
    showError(e)
    const errorItems = { items: Object.assign({}, state.items, { modified: Date.now(), fetching: false, error: "Shoppable searchItems failed. " + e.message, list: [] }) }
    yield put(ShoppableActions.shopStateChange(errorItems))
  }
  finally {
    if (yield cancelled()) {
      const searchParam = typeof search != 'undefined' ? search : ''
      const cancelState = typeof state != 'undefined' ? state : {items:[]}
      console.tron.log(`shoppableSearchItemsAsync search for ${searchParam} cancelled`)
      const errorItems = { items: Object.assign({}, searchParam.items, { modified: Date.now(), fetching: false, error: "Shoppable searchItems cancelled. ", list: [] }, searchSettings) }
      yield put(ShoppableActions.shopStateChange(errorItems))
    }
  }
}

export function* shoppableGetItems(api, action) {
  try {
    const fullState = yield select() // the entire app state
    const options = fullState.postCreation.basePostWallOptions
    const state = fullState.shoppable
    const shoppableConfig = state.config
    const merchants = shoppableConfig.data && shoppableConfig.data.merchants ? shoppableConfig.data.merchants : []
    let items = []
    const { itemIds = [] } = action
    let shoppableItemIds = []
    itemIds.forEach(itemId => {
      shoppableItemIds.push(isShoppableItemId(itemId) ? itemId.substr(0, -5) : itemId)
    })

    if (KargoeConfig.shoppable.active && options.useShoppableTagging && shoppableConfig.data && shoppableConfig.data.enabled) {
      const response = yield call(api.shoppableProductsByPartNumber, itemIds)
      console.tron.display({
        name: `shoppable`,
        preview :`shoppableGetItems ` + (response.ok ? 'success' : 'failure'),
        value: {
          action: action,
          itemIds: itemIds,
          response: response,
        }
      })
      if (response.ok) {
        if (response.data.error) {
          const failedItems = { selectedItems: Object.assign({}, state.selectedItems, { modified: Date.now(), fetching: false, error: `Shoppable: ${response.data.error}` , list: [] }) }
          yield put(ShoppableActions.shopStateChange(failedItems))
          return
        }
        else {
          const shoppableItems = itemIds.length == 1 ?
            [shoppableProductToKargoeItem(merchants, response.data)] :
            response.data.products.map(function (item) {
               return shoppableProductToKargoeItem(merchants, item);
            })
          items = items.concat(shoppableItems)
        }
      }
      else {
        const failedItems = { selectedItems: Object.assign({}, state.selectedItems, { modified: Date.now(), fetching: false, error: 'Shoppable Product API failed', list: [] }) }
        yield put(ShoppableActions.shopStateChange(failedItems))
        return
      }
    } // useShoppableTagging

    const newItems = { selectedItems: Object.assign({}, state.selectedItems, { modified: Date.now(), fetching: false, list: items }) }
    console.tron.display({
      name: `shoppable`,
      preview :`shoppableGetItems processed items`,
      value: {
        items: items,
        newItems: newItems,
      }
    })
    yield put(ShoppableActions.shopStateChange(newItems))
  }
  catch (e) {
    showError(e)
    const errorItems = { selectedItems: Object.assign({}, state.selectedItems, { modified: Date.now(), fetching: false, error: "Shoppable getItems failed. " + e.message, list: [] }) }
    yield put(ShoppableActions.shopStateChange(errorItems))
  }
}

export function* shoppableGetVariants(api, action) {
  let state = null
  try {
    const fullState = yield select() // the entire app state
    state = fullState.shoppable
    let config = Object.assign({}, state.config)
    console.tron.display({
      name: `shoppable`,
      preview :`shoppableGetVariants state`,
      value: {
        state: state
      }
    })
    const { itemId } = action
    if (true) {
      const response = yield call(api.shoppableProductsByPartNumber, itemId)
      console.tron.display({
        name: `shoppable`,
        preview :`shoppableGetVariants response ` + (response.ok ? 'success' : 'failure'),
        value: {
          action: action,
          itemId: itemId,
          response: response,
        }
      })
      if (response.ok) {
        const record = response.data
        if (typeof record.error != 'undefined') {
          const errorVariants = { variants: { modified: Date.now(), fetching: false, error: record.error, itemId: itemId, data: null } }
          yield put(ShoppableActions.shopStateChange(errorVariants))
          return
        }
        const okVariants = { variants: { modified: Date.now(), fetching: false, error: null, itemId: itemId, data: record } }
        console.tron.display({
          name: `shoppable`,
          preview :`shoppableGetVariants update variants`,
          value: {
            okVariants: okVariants
          }
        })
        yield put(ShoppableActions.shopStateChange(okVariants))
      }
      else {
        const errorVariants = { variants: { modified: Date.now(), fetching: false, error: `Unable to get Shoppable variants for product ${itemId}`, itemId: itemId, data: null } }
        yield put(ShoppableActions.shopStateChange(errorVariants))
        return
      }
    }
  }
  catch (e) {
    showError(e)
    const errorVariants = { variants: { modified: Date.now(), fetching: false, error: `Unable to get Shoppable variants for product ${itemId}, ${e.message}`, itemId: itemId, data: null } }
    yield put(ShoppableActions.shopStateChange(errorVariants))
  }
}

export function* shoppableCreateCartWithItem(api, action) {
  let cartChanges = {}
  let initialCartState = {}
  try {
    const { user, post, tag, item, variant } = action
    const fullState = yield select() // the entire app state
    const state = fullState.shoppable
    initialCartState = state.cart
    const responseCart = yield call(api.shoppableCreateShoppingCart)
    console.tron.display({
      name: `shoppable`,
      preview :`shoppableCreateCartWithItem shoppableCreateShoppingCart response ` + (responseCart.ok ? 'success' : 'failure'),
      value: {
        responseCart: responseCart,
      }
    })
    if (responseCart.ok) {
      const quantity = 1
      const itemId = item.ItemId
      const variantId = variant.id
      const sku = variant.id
      // ok, now add the item to the cart...
      const cartId = responseCart.data.cart.id
      const responseItem = yield call(api.shoppableAddToCart, cartId, sku, quantity)
      console.tron.display({
        name: `shoppable`,
        preview :`shoppableCreateCartWithItem shoppableAddToCart response ` + (responseItem.ok ? 'success' : 'failure'),
        value: {
          responseItem: responseItem,
        }
      })

      if (responseCart.ok) {
        console.tron.log(`shoppableCreateCart worked, post: ` + JSON.stringify(post))
        cartChanges = {
          modified: Date.now(),
          fetching: false,
          cartId: cartId,
          userId: user.UserId,
          content: [
            {
              postId: post['PostId'],
              post: post,
              tag: tag,
              item: item,
              variant: variant,
            }
          ]
        }
        const responseSaveCart = yield call(api.saveCartDetail, cartChanges) // TODO - shoppable url, app name
        console.tron.log(`shoppableCreateCartWithItem responseSaveCart ` + (responseSaveCart.ok ? 'success' : 'failure'))
        if (!responseSaveCart.ok)
          cartChanges = { modified: Date.now(), fetching: false, error: `Unable to save Shoppable cart details` }
      }
      else {
        cartChanges = { modified: Date.now(), fetching: false, error: `Unable to add item to Shoppable shopping cart` }
      }
    }
    else {
      cartChanges = { modified: Date.now(), fetching: false, error: `Unable to create Shoppable shopping cart` }
    }
  } // try
  catch (e) {
    showError(e)
    cartChanges = { modified: Date.now(), fetching: false, error: `Unable to create Shoppable shopping cart, ${e.message}` }
  }
  console.tron.display({
    name: `shoppable`,
    preview :`shoppableCreateCartWithItem update`,
    value: {
      cartChanges: cartChanges
    }
  })
  yield put(ShoppableActions.shopStateChange({cart: Object.assign({}, initialCartState, cartChanges)}))
}

export function* shoppableSetCheckoutUrl(api, action) {
  let newCheckout = {
    modified:   Date.now(),
    url:        null,
    error:      null,
  }
  try {
    const { url } = action
    const fullState = yield select() // the entire app state
    const state = fullState.shoppable
    initialCheckoutState = state.checkout
    newCheckout.url = url
  } // try
  catch (e) {
    showError(e)
    newCheckout.error = `Unable to create Shoppable shopping cart, ${e.message}`
  }
  console.tron.display({
    name: `shoppable`,
    preview :`shoppableSetCheckoutUrl update`,
    value: {
      newCheckout: newCheckout
    }
  })
  yield put(ShoppableActions.shopStateChange({checkout: newCheckout}))
}
